var _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGaussianSplat(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2.625 0.9375 2.625 0.9375 5 2 C5 2.66 5 3.32 5 4 C2.36 4 -0.28 4 -3 4 C-2.67 3.01 -2.34 2.02 -2 1 C-1.34 0.67 -0.68 0.34 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(11,0)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0 1.32 0 2 0 C2 0.66 2 1.32 2 2 C2.66 2 3.32 2 4 2 C4 2.66 4 3.32 4 4 C0.25 5.125 0.25 5.125 -2 4 C-2 3.34 -2 2.68 -2 2 C-1.34 2 -0.68 2 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(11,19)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.98 0 3.96 0 6 0 C5.34 1.98 4.68 3.96 4 6 C3.34 6 2.68 6 2 6 C1.34 4.02 0.68 2.04 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(9,9)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.32 0.33 2.64 0.66 4 1 C4 2.98 4 4.96 4 7 C2.68 6.34 1.36 5.68 0 5 C0 3.35 0 1.7 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(18,4)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0 1.65 0 3.3 0 5 C-0.66 5 -1.32 5 -2 5 C-2.66 5.66 -3.32 6.32 -4 7 C-4 5.02 -4 3.04 -4 1 C-2 0 -2 0 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(6,4)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.28875 0.639375 0.5775 1.27875 0.875 1.9375 C1.82823451 4.15206079 1.82823451 4.15206079 4 5 C4 5.66 4 6.32 4 7 C2.68 6.67 1.36 6.34 0 6 C0 4.02 0 2.04 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(2,13)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1 1.98 1 3.96 1 6 C-0.32 6.33 -1.64 6.66 -3 7 C-3 6.34 -3 5.68 -3 5 C-2.34 4.67 -1.68 4.34 -1 4 C-0.34786708 1.97536745 -0.34786708 1.97536745 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(21,13)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGaussianSplat);
export default __webpack_public_path__ + "static/media/gaussian-splat.c271c3366663f2c3ca01d16cf1c61eab.svg";
export { ForwardRef as ReactComponent };